import React from "react";
import checked from "./../../../../Images/checked.png";

const NailExtensionInLavelleWhy = () => {
  return (
    <div className="hairSalonInSahakaraWhy">
      <h5>
        Why SCENT Is the Best Choice for Nail Extensions Near Lavelle Road
      </h5>
      <p>
        Choosing SCENT for nail extensions near Lavelle Road means trusting a
        salon that prioritizes client satisfaction and quality. Here’s why we
        stand out:
      </p>
      <ul>
        <li>
          <span>
            <img src={checked} alt="checked" />
            Expertise{" "}
          </span>
          <p>
            Our skilled technicians have years of experience and stay updated on
            the latest techniques.
          </p>
        </li>{" "}
        <li>
          <span>
            <img src={checked} alt="checked" />
            Customized Service{" "}
          </span>
          <p>
            We offer personalized consultations to ensure you get the exact look
            you want.
          </p>
        </li>
        <li>
          <span>
            <img src={checked} alt="checked" />
            Premium Products{" "}
          </span>
          <p>
            Our selection of high-quality materials ensures beautiful,
            long-lasting results.
          </p>
        </li>
        <li>
          <span>
            <img src={checked} alt="checked" />
            Luxurious Atmosphere{" "}
          </span>
          <p>
            Our salon is a tranquil space designed to make you feel relaxed and
            pampered.
          </p>
        </li>
        <li>
          <span>
            <img src={checked} alt="checked" />
            Hygiene and Safety{" "}
          </span>
          <p>
            We maintain rigorous hygiene standards for a clean, safe experience.
          </p>
        </li>
      </ul>
    </div>
  );
};

export default NailExtensionInLavelleWhy;
